import React from 'react';
import classNames from 'classnames';

import css from './Topbar.module.css';

/**
 * Search icon (magnifier icon)
 *
 * @component
 * @param {Object} props
 * @param {string?} props.className add more style rules in addition to components own css.root
 * @param {string?} props.rootClassName overwrite components own css.root
 * @returns {JSX.Element} search icon
 */
const SearchIcon = props => {
  const { className, rootClassName } = props;
  const classes = classNames(rootClassName || css.rootSearchIcon, className);

  return (
    <svg className={classes} width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M17.5 18L22 22.5M20 11.5C20 9.11305 19.0518 6.82387 17.364 5.13604C15.6761 3.44821 13.3869 2.5 11 2.5C8.61305 2.5 6.32387 3.44821 4.63604 5.13604C2.94821 6.82387 2 9.11305 2 11.5C2 13.8869 2.94821 16.1761 4.63604 17.864C6.32387 19.5518 8.61305 20.5 11 20.5C13.3869 20.5 15.6761 19.5518 17.364 17.864C19.0518 16.1761 20 13.8869 20 11.5Z" stroke="#1A1B2F" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
    
  );
};

export default SearchIcon;
